var _path, _g, _path2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_633_5472",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.667969 0.666016H16.8986V16.8968H0.667969V0.666016Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_633_5472)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7838 1.91602C4.99797 1.91602 1.91797 4.99518 1.91797 8.78102C1.91797 12.5668 4.99797 15.6468 8.7838 15.6468C12.5688 15.6468 15.6488 12.5668 15.6488 8.78102C15.6488 4.99518 12.5688 1.91602 8.7838 1.91602M8.7838 16.8968C4.3088 16.8968 0.667969 13.256 0.667969 8.78102C0.667969 4.30602 4.3088 0.666016 8.7838 0.666016C13.2588 0.666016 16.8988 4.30602 16.8988 8.78102C16.8988 13.256 13.2588 16.8968 8.7838 16.8968",
    fill: "#5D6373"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_633_5472",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 5,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3672 13.7559H17.5539V17.9348H13.3672V13.7559Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_633_5472)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9291 17.9348C16.7699 17.9348 16.6099 17.874 16.4874 17.7523L13.5507 14.824C13.3066 14.5798 13.3057 14.184 13.5499 13.9398C13.7932 13.694 14.1891 13.6957 14.4341 13.9382L17.3707 16.8673C17.6149 17.1115 17.6157 17.5065 17.3716 17.7507C17.2499 17.874 17.0891 17.9348 16.9291 17.9348Z",
    fill: "#5D6373"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.bc611d11b80fd80aca7dc349591535dc.svg";
export { ForwardRef as ReactComponent };